import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.qrScanner,
      callback: function ($$v) {
        _vm.qrScanner = $$v;
      },
      expression: "qrScanner"
    }
  }, [_vm.qrScanner ? _c('niota-classic-devices-qr-form', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.qrScanner')
    },
    on: {
      "close": function ($event) {
        _vm.qrScanner = false;
      }
    }
  }) : _vm._e()], 1), _c(VForm, {
    ref: "form",
    staticClass: "device-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.addNewDevice.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "back": function ($event) {
        return _vm.$emit('reset-originator');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.titleCreate')))];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.reset'),
            "prepend-icon": "fa-arrow-left"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('reset-originator');
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.Devices.form.qrScanner'),
            "prepend-icon": "fa-barcode-read"
          },
          on: {
            "click": function ($event) {
              _vm.qrScanner = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.save'),
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.addNewDevice.apply(null, arguments);
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.title'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.deviceData.title,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "title", $$v);
      },
      expression: "deviceData.title"
    }
  })], 1), !_vm.isUdp && !_vm.isWebhookOrFilesys ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "value": true,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.otaaAbp')
    },
    model: {
      value: _vm.otaa,
      callback: function ($$v) {
        _vm.otaa = $$v;
      },
      expression: "otaa"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypes,
      "filter": _vm.filterItems,
      "return-object": "",
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.deviceData.deviceType,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "deviceType", $$v);
      },
      expression: "deviceData.deviceType"
    }
  })], 1), _vm.isUdp ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.protocol'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: _vm.datasourceType,
      callback: function ($$v) {
        _vm.datasourceType = $$v;
      },
      expression: "datasourceType"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.description'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "rows": "4"
    },
    model: {
      value: _vm.deviceData.description,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "description", $$v);
      },
      expression: "deviceData.description"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-n1-tags', {
    attrs: {
      "tags": _vm.deviceData.tags
    },
    on: {
      "process": _vm.tagsChanged
    }
  })], 1), _vm.deviceData.properties ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.operationalStatus,
      "return-object": "",
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: _vm.deviceData.properties.operational_status,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData.properties, "operational_status", $$v);
      },
      expression: "deviceData.properties.operational_status"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.operationalStatusHint')))])], 1) : _vm._e(), _vm.isFirefly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.adrLimit'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.adrLimits,
      "filter": _vm.filterItems,
      "return-object": "",
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2098911049),
    model: {
      value: _vm.deviceData.adr_limit,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "adr_limit", $$v);
      },
      expression: "deviceData.adr_limit"
    }
  })], 1) : _vm._e(), _vm.isFirefly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.region'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.regions,
      "filter": _vm.filterItems,
      "return-object": "",
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v(_vm._s(item.id))])], 1)];
      }
    }], null, false, 2827820021),
    model: {
      value: _vm.deviceData.region,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "region", $$v);
      },
      expression: "deviceData.region"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.regionHint')))])], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Common.table.eui'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": 'fal fa-pen',
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    on: {
      "click:append": _vm.randomEui
    },
    model: {
      value: _vm.deviceData.eui,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "eui", $$v);
      },
      expression: "deviceData.eui"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.euiHint')))])], 1), !_vm.isUdp && !_vm.isWebhookOrFilesys ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.otaa ? _c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.deviceAddress'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": 'fal fa-pen',
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "click:append": _vm.randomDeviceAddress
    },
    model: {
      value: _vm.deviceData.deviceAddress,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "deviceAddress", $$v);
      },
      expression: "deviceData.deviceAddress"
    }
  }) : _c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.deviceAddress'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": 'fal fa-pen',
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    on: {
      "click:append": _vm.randomDeviceAddress
    },
    model: {
      value: _vm.deviceData.deviceAddress,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "deviceAddress", $$v);
      },
      expression: "deviceData.deviceAddress"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.deviceAddressHint')))])], 1) : _vm._e(), (_vm.isFirefly || _vm.isActility) && _vm.otaa ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.applicationKey'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": 'fal fa-pen',
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    on: {
      "click:append": _vm.randomApplKey
    },
    model: {
      value: _vm.deviceData.applKey,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "applKey", $$v);
      },
      expression: "deviceData.applKey"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.applicationKeyHint')))])], 1) : _vm._e(), (_vm.isFirefly || _vm.isActility) && !_vm.otaa || _vm.isUdp ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.appSessionKey'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": 'fal fa-pen',
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    on: {
      "click:append": _vm.randomApplSessionKey
    },
    model: {
      value: _vm.deviceData.applSessionKey,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "applSessionKey", $$v);
      },
      expression: "deviceData.applSessionKey"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.applSessionKeyHint')))])], 1) : _vm._e(), (_vm.isFirefly || _vm.isActility) && !_vm.otaa || _vm.isUdp ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.networkSessionKey'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": 'fal fa-pen',
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    on: {
      "click:append": _vm.randomNetwSessionKey
    },
    model: {
      value: _vm.deviceData.netwSessionKey,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "netwSessionKey", $$v);
      },
      expression: "deviceData.netwSessionKey"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.networkSessionKeyHint')))])], 1) : _vm._e(), _vm.isActility && _vm.otaa && _vm.deviceData.properties ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.applicationEui'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.deviceData.properties.applicationEUI,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData.properties, "applicationEUI", $$v);
      },
      expression: "deviceData.properties.applicationEUI"
    }
  })], 1) : _vm._e(), _vm.isActility && _vm.deviceData.properties ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.motionIndicator'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.motionIndicators,
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: _vm.deviceData.properties.motionIndicator,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData.properties, "motionIndicator", $$v);
      },
      expression: "deviceData.properties.motionIndicator"
    }
  })], 1) : _vm._e(), _vm.isActility ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [!_vm.actilityOptionsIsLoading ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.connectivityPlan'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.connectivityPlans,
      "filter": _vm.filterConnectivityPlan,
      "rules": [() => !!_vm.deviceData.connectivity_plans || this.$i18n_t('Common.fieldRequired')],
      "required": "",
      "return-object": "",
      "auto-select-first": "",
      "item-text": "name",
      "item-value": "id",
      "clearable": "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))]), _c(VListItemSubtitle, [_vm._v(_vm._s(item.communicationType) + ": " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2025234246),
    model: {
      value: _vm.deviceData.connectivity_plans,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "connectivity_plans", $$v);
      },
      expression: "deviceData.connectivity_plans"
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm.isActility ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [!_vm.actilityOptionsIsLoading ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.manufacturerModel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceProfiles,
      "filter": _vm.filterConnectivityPlan,
      "rules": [() => !!_vm.deviceData.device_profiles || this.$i18n_t('Common.fieldRequired')],
      "required": "",
      "return-object": "",
      "auto-select-first": "",
      "item-text": "name",
      "item-value": "id",
      "clearable": "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))]), _c(VListItemSubtitle, [_vm._v(_vm._s(item.id))])], 1)];
      }
    }], null, false, 704794482),
    model: {
      value: _vm.deviceData.device_profiles,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "device_profiles", $$v);
      },
      expression: "deviceData.device_profiles"
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm.isFirefly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.specificOrganization'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.deviceData.specOrga,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "specOrga", $$v);
      },
      expression: "deviceData.specOrga"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.specificOrganizationHint')))])], 1) : _vm._e(), _vm.isFirefly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceClassID'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.deviceData.deviceClassID,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "deviceClassID", $$v);
      },
      expression: "deviceData.deviceClassID"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.deviceClassIDHint')))])], 1) : _vm._e(), _vm.isFirefly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    staticClass: "shrink mx-0 my-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.classC'),
      "hide-details": ""
    },
    model: {
      value: _vm.deviceData.class_c,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "class_c", $$v);
      },
      expression: "deviceData.class_c"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.classCHint')))])], 1) : _vm._e(), _vm.isFirefly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    staticClass: "shrink mx-0 my-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.overrideLocation'),
      "hide-details": ""
    },
    model: {
      value: _vm.deviceData.override_location,
      callback: function ($$v) {
        _vm.$set(_vm.deviceData, "override_location", $$v);
      },
      expression: "deviceData.override_location"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.overrideLocationHint')))])], 1) : _vm._e()], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-address-picker', {
    attrs: {
      "addressObject": _vm.addressObject,
      "coordinateLookup": _vm.coordinateLookup,
      "floatRule": false
    },
    on: {
      "address-selected": _vm.addressSelected
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };